export default "__VITE_ASSET__Pwp9t38v__"